import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import Toast from '../components/shared/Toast';

const NotificationContext = createContext({
  toast: null,
  showToast: () => {},
  hideToast: () => {}
});

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = 'info') => {
    setToast({ message, type });
  }, []);

  const hideToast = useCallback(() => {
    setToast(null);
  }, []);

  const value = useMemo(() => ({
    toast,
    showToast,
    hideToast
  }), [toast, showToast, hideToast]);

  return (
    <NotificationContext.Provider value={value}>
      {children}
      {toast && <Toast message={toast.message} type={toast.type} onClose={hideToast} />}
    </NotificationContext.Provider>
  );
};
